import * as React from "react";
const ClipboardIcon = (props) => (
  <svg
  width={20}
  height={24}
    id="katman_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20 24"
    enableBackground="new 0 0 20 24"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <g>
        <path
          fill="#CB8252"
          d="M17.9,24H2.1c-1,0-1.7-0.8-1.7-1.7V3.1c0-1,0.8-1.7,1.7-1.7h15.8c1,0,1.7,0.8,1.7,1.7v19.2 C19.6,23.2,18.9,24,17.9,24z"
        />
        <path
          fill="#ECF0F1"
          d="M17.6,22.2H2.4c-0.2,0-0.4-0.2-0.4-0.4v-18c0-0.2,0.2-0.4,0.4-0.4h15.1c0.2,0,0.4,0.2,0.4,0.4v18 C18,22.1,17.8,22.2,17.6,22.2z"
        />
      </g>
      <g>
        <path
          fill="#E64C3C"
          d="M9.4,5.7l-4.3,6.6c-0.4,0.7,0,1.5,0.8,1.5h8.1c0.8,0,1.2-0.8,0.8-1.5l-4.3-6.7C10.3,5.3,9.7,5.3,9.4,5.7z"
        />
        <g>
          <path
            fill="#ECF0F1"
            d="M10,11.1L10,11.1c-0.2,0-0.4-0.2-0.4-0.4V8c0-0.2,0.2-0.4,0.4-0.4l0,0c0.2,0,0.4,0.2,0.4,0.4v2.6 C10.4,10.9,10.2,11.1,10,11.1z"
          />
          <circle fill="#ECF0F1" cx={10} cy={12.3} r={0.4} />
        </g>
      </g>
      <path
        fill="#547580"
        d="M11.5,16.5H3.9c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4h7.6c0.2,0,0.4,0.2,0.4,0.4v0 C11.9,16.3,11.7,16.5,11.5,16.5z"
      />
      <path
        fill="#547580"
        d="M11.6,19.8H4c-0.2,0-0.4-0.2-0.4-0.4v0c0-0.2,0.2-0.4,0.4-0.4h7.6c0.2,0,0.4,0.2,0.4,0.4v0 C12,19.6,11.8,19.8,11.6,19.8z"
      />
      <path
        fill="#4FBA6F"
        d="M16.1,15c-0.2-0.2-0.5-0.2-0.6,0l-1,0.9l-0.2-0.3c-0.2-0.2-0.5-0.2-0.6,0h0c-0.2,0.2-0.2,0.5,0,0.6l0.5,0.6 c0.2,0.2,0.5,0.2,0.6,0v0c0,0,0,0,0,0c0,0,0,0,0,0l1.2-1.1C16.3,15.4,16.3,15.2,16.1,15z"
      />
      <path
        fill="#4FBA6F"
        d="M16.1,18.3c-0.2-0.2-0.5-0.2-0.6,0l-1,0.9l-0.2-0.3c-0.2-0.2-0.5-0.2-0.6,0h0c-0.2,0.2-0.2,0.5,0,0.6 l0.5,0.6c0.2,0.2,0.5,0.2,0.6,0v0c0,0,0,0,0,0c0,0,0,0,0,0l1.2-1.1C16.3,18.7,16.3,18.4,16.1,18.3z"
      />
      <path
        fill="#95A5A5"
        d="M13.4,0.8h-1.4c-0.2,0-0.5-0.1-0.7-0.2c-1.2-1-2.3-0.4-2.8,0C8.4,0.7,8.2,0.8,7.9,0.8H6.6 c-0.4,0-0.7,0.3-0.7,0.7V3c0,0.4,0.3,0.7,0.7,0.7h6.9c0.4,0,0.7-0.3,0.7-0.7V1.5C14.2,1.1,13.9,0.8,13.4,0.8z"
      />
      <circle fill="#7F8C8D" cx={10.1} cy={1.6} r={0.4} />
    </g>
  </svg>
);
export default ClipboardIcon;
